import CryptoJS from 'crypto-js';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

/**
 * Decrypted session role for ESM callers (Vite has no CommonJS require).
 * Returns '' when the cookie cannot be read. Role-gated search and routes
 * treat that empty value as denied.
 */
export default function currentUserRole() {
  try {
    const userRoleCookie = cookies.get('userRole');
    const email = typeof localStorage !== 'undefined' ? localStorage.getItem('email') : null;
    if (!userRoleCookie || !email) {
      return '';
    }
    return CryptoJS.AES.decrypt(userRoleCookie, email.split('@')[0].toLowerCase()).toString(CryptoJS.enc.Utf8) || '';
  } catch {
    return '';
  }
}
